<template>
  <div>
    <div class="columns is-multiline egoEvents">
      <template v-if="events.length">
        <ActivityList
          v-for="event in events"
          class="is-one-third"
          :key="event.id"
          :event="event"
          :branches="branches"
          :eventStatusKey="'events_status'"
        />
      </template>

      <div class="warn-tip-container" v-if="!events.length">
        <span class="warn-tip">暂无活动</span>
      </div>
      <!-- <div class="getMore-container">
        <div @click="getMore" v-if="Number(pageInfo.pages)>Number(pageInfo.current_page)" class="get-more">
          加载更多
        </div>
      </div> -->
    </div>
    <MoreButton
      v-if="events.length"
      :loading="loading"
      :end="isEnd"
      :loadingCount="loadingCount"
      @click="getMore"
    />
  </div>
</template>
<script>
import ActivityList from '@/components/list/ActivityList'
import MoreButton from '@/components/button/MoreButton.vue'

export default {
  props: ['events', 'pageInfo', 'branches', 'isEnd', 'loadingCount', 'loading'],
  data () {
    return {
      mapStatus: {
        '3': '已结束',
        '2': '进行中',
        '1': '未开始'
      }
    }
  },
  components: {
    ActivityList,
    MoreButton
  },
  methods: {
    getMore ({ clear }) {
      let params = {
        isCurTagChange: false,
        pageNum: ++this.pageInfo.current_page
      }
      this.$emit('getMore', params)
      clear && clear()
    }
  },
  created () {},
  watch: {},
  computed: {
  },
  filters: {
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

// 查看更多
.getMore-container
  width: 100%
  display: flex
  justify-content: center
  padding-top: 30px
  .get-more
    cursor: pointer
    color: $primary3
    font-size: 18px
    padding: 8px 84px
    border: 1px solid $primary3
    border-radius: 5px

// 暂无活动
.warn-tip-container
  display: flex
  justify-content: center
  align-items: center
  width: 100%
  margin-top: 50px
  .warn-tip
    font-size: 18px
    color: $primary3

.egoEvents
  margin-top: 20px

</style>
